import { PageMeta } from '../insights/insights.models';

export const COURSES_PAGE_META: Record<string, PageMeta> = {
	'^/courses/\\d+/enrollments': {
		pagegroup: 'courses',
		pagename: 'enrollments'
	}
};
